/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-11-24T09:40:19.575
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listKhmDataChangesApply,
	listKhmDataChangesApplyInit,
	listKhmDataChangesApplyByAuthorizations,
	deleteKhmDataChangesApply
	
} from '@api/rentmanage/KhmDataChangesApply';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listKhmDataChangesApply({
			state
		}) {
			return new Promise((resolve, reject) => {
				listKhmDataChangesApply(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listKhmDataChangesApplyByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listKhmDataChangesApplyByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listKhmDataChangesApplyInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listKhmDataChangesApplyInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						state.CompoundEntities.rowFunctionAuthorization = res.rowFunctionAuthorization;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteKhmDataChangesApply({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteKhmDataChangesApply({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
